import { Routes } from '@angular/router';

export const qrCodeRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./qr-code.page').then((m) => m.QrCodePage),
  },
];
